var cookieNotice = function () {

  var publicMethods = {};

  var wrapper;
  var cookie;
  var activeStageClass = 'c-cookie-notice__stage--active';
  var showClass = 'c-cookie-notice--show';
  var formButtonClass = ' btn btn-inverse';
  var formButtonSecondaryClass = ' c-cookie-notice__button--secondary';
  var consentSignalsDataAttribute = 'data-cookie-notice-checkbox-consent-signals';
  var refreshOnFirstDecision = true;
  var version = 2;

  var reviewButton;
  var isReviewing = false;

  publicMethods.init = function () {

    cookie = getCookie('cookieNotice');

    var validCookieData = cookie ? isValidVersion(cookie) : false;

    if (validCookieData) {

      updateConsentSignals(cookie);

    } else {

      deleteCookie('cookieNotice');
      window.addEventListener('load', function () { appendNotice(); });

    }

    window.addEventListener('load', function () { assignReviewButtonEvent(); });

  };

  function isValidVersion(cookie) {

    var data;
    var jsonParseError = false;

    try {

      data = JSON.parse(cookie);

    } catch(e) {

      jsonParseError = true;

    }

    if (jsonParseError) return false;

    if (typeof data !== 'object') return false; // not an object (it's the old notice), not a valid version of the notice
    if (data['version'] === undefined) return false; // no version, not a valid version of the notice
    if (data['version'] !== version) return false; // version mismatch, not a valid version of the notice
    if (data['categories'] === undefined) return false; // no categories, not a valid version of the notice
    if (!Array.isArray(data['categories'])) return false; // categories is not an array, not a valid version of the notice

    return true;

  }

  function assignReviewButtonEvent() {

    reviewButton = document.querySelector('[data-cookie-notice-review]');

    if (!reviewButton) return;

    reviewButton.addEventListener('click', function () {

      isReviewing = true;
      appendNotice();

    });

  };

  function hideCookieNotice() {

    wrapper.classList.remove(showClass);

    setTimeout(function () {

      wrapper.remove();

      if (isReviewing) {

        var changesMade = JSON.stringify(cookie) !== JSON.stringify(getCookie('cookieNotice'));
        if (!changesMade) return;

        showLoaderAndRefresh();

      } else {

        if (refreshOnFirstDecision) showLoaderAndRefresh();

      }

    }, 750);

  };

  function buttonAllowClick() {

    var data = getCookieData(true);

    if (!isReviewing) updateConsentSignals(data);
    setCookie('cookieNotice', data, 30);
    hideCookieNotice();

  };

  function buttonSaveClick() {

    var data = getCookieData(false);

    if (!isReviewing) updateConsentSignals(data);
    setCookie('cookieNotice', data, 30);
    hideCookieNotice();

  };

  function buttonRejectClick() {

      var data = getCookieDataAndRejectAll();
      setCookie('cookieNotice', data, 30);
      hideCookieNotice();

  };

  function buttonManageClick() {

    document.querySelector('[data-cookie-notice-stage="one"]').classList.remove(activeStageClass);
    document.querySelector('[data-cookie-notice-stage="two"]').classList.add(activeStageClass);

    trapFocus(wrapper, '[data-cookie-notice-stage="one"]');

    var elementsToFocusOn = document.querySelectorAll('[data-cookie-notice-checkbox]:not([disabled])');
    if (elementsToFocusOn.length) elementsToFocusOn[0].focus();

  };

  function appendNotice() {

    if (!canAppendNotice()) return;

    var categoryHtml = getCategoryHtml();

    var noticeHtml =
    '<div class="c-cookie-notice" data-cookie-notice role="dialog" aria-labelledby="cookie-notice-title" aria-describedby="cookie-notice-description">' +
      '<div class="c-cookie-notice__inner">' +
        '<div class="c-cookie-notice__inner__inner">' +
          '<p class="c-cookie-notice__title" id="cookie-notice-title">' + cookieNoticeSettings.title + '</p>' +
          '<div class="c-cookie-notice__description">' +
            '<p id="cookie-notice-description">' + cookieNoticeSettings.content + ' <a href="' + cookieNoticeSettings.infoLink + '" aria-label="' + cookieNoticeSettings.infoLinkAriaLabel + '">' + cookieNoticeSettings.infoLinkText + '</a></p>' +
          '</div>' +
          '<div class="c-cookie-notice__stage c-cookie-notice__stage--active" data-cookie-notice-stage="one">' +
            '<div class="c-cookie-notice__actions">' +
              '<p class="c-cookie-notice__action"><button type="button" class="c-cookie-notice__button' + formButtonClass + '" data-cookie-notice-button="allow" aria-label="' + cookieNoticeSettings.allowAllAriaLabel + '"><span class="btn-inner">' + cookieNoticeSettings.allowAllText + '</span></button></p>' +
              '<p class="c-cookie-notice__action"><button type="button" class="c-cookie-notice__button' + formButtonClass + '" data-cookie-notice-button="reject" aria-label="' + cookieNoticeSettings.rejectAllAriaLabel + '"><span class="btn-inner">' + cookieNoticeSettings.rejectAllText + '</span></button></p>' +
              '<p class="c-cookie-notice__action"><button type="button" class="c-cookie-notice__button' + formButtonClass + formButtonSecondaryClass + '" data-cookie-notice-button="manage" aria-controls="cookie-notice-manage" aria-expanded="false" aria-label="' + cookieNoticeSettings.manageAriaLabel + '"><span class="btn-inner">' + cookieNoticeSettings.manageText + '</span></button></p>' +
            '</div>' +
          '</div>' +
          '<div class="c-cookie-notice__stage" data-cookie-notice-stage="two" id="cookie-notice-manage">' +
            '<div class="c-cookie-notice__actions">' +
              '<p class="c-cookie-notice__action"><button type="button" class="c-cookie-notice__button' + formButtonClass + '" data-cookie-notice-button="allow" aria-label="' + cookieNoticeSettings.allowAllAriaLabel + '"><span class="btn-inner">' + cookieNoticeSettings.allowAllText + '</span></button></p>' +
              '<p class="c-cookie-notice__action"><button type="button" class="c-cookie-notice__button' + formButtonClass + '" data-cookie-notice-button="reject" aria-label="' + cookieNoticeSettings.rejectAllAriaLabel + '"><span class="btn-inner">' + cookieNoticeSettings.rejectAllText + '</span></button></p>' +
            '</div>' +
            categoryHtml +
            '<div class="c-cookie-notice__actions">' +
              '<p class="c-cookie-notice__action"><button type="button" class="c-cookie-notice__button' + formButtonClass + formButtonSecondaryClass + '" data-cookie-notice-button="save" aria-label="' + cookieNoticeSettings.saveAriaLabel + '"><span class="btn-inner">' + cookieNoticeSettings.saveText + '</span></button></p>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>';

    document.body.insertAdjacentHTML('afterbegin', noticeHtml);

    wrapper = document.querySelector('[data-cookie-notice]');
    var allowButtons = document.querySelectorAll('[data-cookie-notice-button="allow"]');
    var manageButton = document.querySelector('[data-cookie-notice-button="manage"]');
    var saveButton = document.querySelector('[data-cookie-notice-button="save"]');
    var rejectButtons = document.querySelectorAll('[data-cookie-notice-button="reject"]');

    manageButton.addEventListener('click', function () {

      buttonManageClick();
      manageButton.setAttribute('aria-expanded', 'true');

    });

    saveButton.addEventListener('click', buttonSaveClick);
    scopedLoop(allowButtons, function (button, i, context) { button.addEventListener('click', buttonAllowClick); }, this);
    scopedLoop(rejectButtons, function (button, i, context) { button.addEventListener('click', buttonRejectClick); }, this);

    wrapper.classList.add(showClass);

    trapFocus(wrapper, '[data-cookie-notice-stage="two"]');

    wrapper.setAttribute('tabindex', 0);
    wrapper.focus();
    wrapper.removeAttribute('tabindex');

  };

  function getCategoryHtml() {

    var html = '<ul class="c-cookie-notice__categories">';

    var existingCookie = getCookie('cookieNotice');
    var existingCookieData = existingCookie ? JSON.parse(existingCookie) : false;

    scopedLoop(cookieNoticeSettings.categories, function (category, i, context) {

      var acceptanceMarkUp = category.forceAcceptance ? 'checked disabled ' : 'checked';
      var acceptanceClass = category.forceAcceptance ? ' is-disabled' : '';
      var checkboxId = 'cookie-notice-checkbox-' + i;
      var consentSignals = getConsentSignalsForCategory(category);

      acceptanceMarkUp = (!category.forceAcceptance && existingCookieData && !checkIfCategoryTrue(category.category, existingCookieData)) ? '' : acceptanceMarkUp;

      html +=
      '<li class="c-cookie-notice__categories__item">' +
        '<div class="c-cookie-notice__categories__title">' +
          '<input type="checkbox" class="c-cookie-notice__categories__title__checkbox" id="' + checkboxId + '" value="' + category.category + '"' + acceptanceMarkUp + ' data-cookie-notice-checkbox="' + i + '" ' + consentSignalsDataAttribute + '="' + consentSignals.toString() + '"/>' +
          '<label class="c-cookie-notice__categories__title__label' + acceptanceClass + '" for="' + checkboxId + '">' +
            '<span class="c-cookie-notice__categories__title__text">' + category.title + '</span>' +
          '</label>' +
        '</div>' +
        '<div class="c-cookie-notice__categories__description">' +
          '<p>' + category.description + '</p>' +
        '</div>' +
      '</li>';

    }, this);

    html += '</ul>';

    return html;

  };

  function getConsentSignalsForCategory(category) {

    var consentSignals = category.consentSignals;

    var sanitisedConsentSignals = [];

    scopedLoop(consentSignals, function (signal, i, context) {

      sanitisedConsentSignals.push(signal.replace(/\s/g,''));
    
    }, this);

    return sanitisedConsentSignals;

  }

  function checkIfCategoryTrue(category, existingCookieData) {

    var result = false;
    var breakOutOfLoop = false;

    for (var i = 0; i < existingCookieData.categories.length; i++) {

     if (breakOutOfLoop) break;

      (function (i) {

        if (existingCookieData.categories[i].category === category) {

          result = existingCookieData.categories[i].checked;
          breakOutOfLoop = true;

        }

      })(i);

    }

    return result;

  };

  function canAppendNotice() {

    var result = true;

    if (isReviewing) {
      return result;
    }

    if (cookieNoticeSettings.infoLink) {

      var currentUrl = window.location.href.toLowerCase();
      if (currentUrl.indexOf(cookieNoticeSettings.infoLink.toLowerCase()) !== -1) { result = false; }

    }

    return result;

  };

  function getCookieData(allowAll) {

    var data = {
      version: version,
      categories: []
    };

    var checkboxes = wrapper.querySelectorAll('input[type="checkbox"]');

    scopedLoop(checkboxes, function (checkbox, i, context) {

      var isChecked = checkbox.checked || allowAll;
      var consentSignals = checkbox.getAttribute(consentSignalsDataAttribute).split(',');

      data.categories.push({
        category: checkbox.value,
        checked: isChecked,
        consentSignals: consentSignals
      });

    }, this);

    return JSON.stringify(data);

  };

  function getCookieDataAndRejectAll() {

    var data = {
      version: version,
      categories: []
    };

    var checkboxes = wrapper.querySelectorAll('input[type="checkbox"]');

    scopedLoop(checkboxes, function (checkbox, i, context) {

      var consentSignals = checkbox.getAttribute(consentSignalsDataAttribute).split(',');

      if (checkbox.disabled) {

        data.categories.push({
          category: checkbox.value,
          checked: true,
          consentSignals: consentSignals
        });

      } else {

        data.categories.push({
          category: checkbox.value,
          checked: false,
          consentSignals: consentSignals
        });

      }

    }, this);
  
    return JSON.stringify(data);

  }

  function updateConsentSignals(data) {

    var parsedData = JSON.parse(data);

    var grantedConsentSignals = [];

    for (var i = 0; i < parsedData.categories.length; i++) {

      (function (i) {

        if (parsedData.categories[i].checked) {

          for (var j = 0; j < parsedData.categories[i].consentSignals.length; j++) {

            (function (j) {

              var consentSignal = parsedData.categories[i].consentSignals[j];

              if (
                consentSignal !== '' &&
                grantedConsentSignals.indexOf(consentSignal) === -1
              ) {

                grantedConsentSignals.push(consentSignal);

              }

            })(j);

          }

      }

      })(i);

    }

    window.addEventListener('load', function () {

      var event = new CustomEvent('consentSignalsUpdated', {
        detail: {
          data: parsedData,
          consentSignals: grantedConsentSignals
        }
      });

      document.dispatchEvent(event);

    });

    if (!grantedConsentSignals.length) return;

    var grantedConsentObject = {};

    for (var i = 0; i < grantedConsentSignals.length; i++) {

      (function (i) {

        grantedConsentObject[grantedConsentSignals[i]] = 'granted';

      })(i);

    }

    window.gtag('consent', 'update', grantedConsentObject);

  };

  function trapFocus(element, parentIgnoreSelector) {

    var potentiallyFocusableElements = element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');

    var focusableEls = [];

    if (parentIgnoreSelector) {

      scopedLoop(potentiallyFocusableElements, function (focusableEl, i, context) {

        if (!focusableEl.closest(parentIgnoreSelector)) focusableEls.push(focusableEl);

      }, this);

    } else {

      focusableEls = potentiallyFocusableElements;

    }

    var firstFocusableEl = focusableEls[0];
    var lastFocusableEl = focusableEls[focusableEls.length - 1];
    var KEYCODE_TAB = 9;

    element.addEventListener('keydown', function (e) {

      var isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);

      if (!isTabPressed) {
        return;
      }

      if (e.shiftKey) { // if shift key pressed for shift + tab combination

        if (document.activeElement === firstFocusableEl) {

          lastFocusableEl.focus();
          e.preventDefault();

        }

      } else { // if tab key is pressed

        if (document.activeElement === lastFocusableEl) {

          firstFocusableEl.focus();
          e.preventDefault();

        }

      }

    });

  };

  function scopedLoop(items, fn, context) {

    for (var i = 0; i < items.length; i++) { (function (i) { fn(items[i], i, context); }).call(this, i); }

  };

  function setCookie(n, t, i) {

    var r = new Date, u;
    r.setDate(r.getDate() + i);
    u = escape(t) + (i === null ? "" : ";  expires=" + r.toUTCString() + ";path=/");
    document.cookie = n + "=" + u;

  };

  function deleteCookie(n) {

    setCookie(n, null, -1);

  };

  function getCookie(n) {

    var t = document.cookie, i = t.indexOf(" " + n + "="), r;
    return i === -1 && (i = t.indexOf(n + "=")), i == -1 ? t = null : (i = t.indexOf("=", i) + 1, r = t.indexOf(";", i), r == -1 && (r = t.length), t = unescape(t.substring(i, r))), t;

  };

  function showLoaderAndRefresh() {

    var loader = document.createElement('div');
    loader.setAttribute('class', 'c-cookie-notice-loader')
    loader.innerHTML = '<div class="c-cookie-notice-loader__inner"><div class="c-cookie-notice-loader__spinner"></div><div class="c-cookie-notice-loader__message"><div class="c-cookie-notice-loader__message__inner" role="status">Updating<span class="c-cookie-notice-accessible-hide"> your</span> preferences<span class="c-cookie-notice-accessible-hide"> - page will refresh</span></div></div></div>';

    document.body.appendChild(loader);

    setTimeout(function () { location.reload(); }, 1000);

  };

  return publicMethods;

}();

cookieNotice.init();
